import { Injectable, ViewContainerRef } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SrcPipe } from '../../src.pipe';
import { FilePreviewComponent } from './file-preview.component';


@Injectable({
  providedIn: 'root'
})
export class FilePreviewService {

  constructor(private modal: NzModalService, private srcPip: SrcPipe) {


  }


  filePreview(_url: string, name: string, type: string) {
    var _url = this.srcPip.transform(_url);

    var canPreview = false;
    switch (type) {
      case ".mp3":
      case ".wav":
      case ".ogg":
        canPreview = true;
        break;
      case ".pdf":
        canPreview = true;
        break;
      case ".txt":
        canPreview = true;
        break;
      default:
        canPreview = false;
        break;
    }

    if (canPreview) {
      this.show(_url, name);
    }else{
      window.open(_url);
    }


  }

  private show(_url: string, name: string) {

    const modal = this.modal.create({
      nzTitle: name,
      nzWidth: document.body.offsetWidth,
      nzStyle :{ top: '10px' },
      nzContent: FilePreviewComponent,
      nzComponentParams: {
        url: _url
      },
      nzFooter: [{
        label: '下载',
        type: 'dashed',
        onClick: () => {

          window.open(_url);
        }
      }],
      nzOnOk: () => { }
    });
    const instance = modal.getContentComponent();
    modal.afterOpen.subscribe(() => {


    });
    // Return a result when closed
    modal.afterClose.subscribe(result => {


    });
  }
}
